module.exports = __webpack_public_path__ + "img/empty_1.556bd7d2.png";